// extracted by mini-css-extract-plugin
module.exports = {"container":"AnonymousApp_container__Rn9fZ container-fluid","wrapper":"AnonymousApp_wrapper__2--Bl","main":"AnonymousApp_main__2Sgxx"};